import TileConfigAdaptor from './TileConfigAdaptor';

/**
 * TileConfigAdaptorV3 - Uses the V3 tileset-index endpoint
 * Extends TileConfigAdaptor to use /v3/tileset-index instead of /v2/tileset
 */
export default class TileConfigAdaptorV3 extends TileConfigAdaptor {
	static override _endpointPathname = '/v3/tileset-index';
}

export const tilesConfigCreatorV3 =
	TileConfigAdaptorV3.creator.bind(TileConfigAdaptorV3);
